import { schema } from "normalizr";
const inventoryModifier = new schema.Entity("inventoryModifier");

const Schemas = {
    INVENTORY_MODIFIER: inventoryModifier,
    INVENTORY_MODIFIERS_ARRAY: { data: [inventoryModifier] }
};

export default Schemas;
